import React, { memo } from "react";

import { Tag } from "antd";

type SmsPackageStatusProps = {
  status?: "C" | "A" | "P";
};

const SmsPackageStatus = ({ status }: SmsPackageStatusProps) => {
  const isCanceled = status === "C";
  const config = {
    color: isCanceled ? "error" : "success",
    label: isCanceled ? "Cancelado" : "Ativado",
  };
  return <Tag color={config.color}>{config.label}</Tag>;
};

SmsPackageStatus.defaultProps = {
  status: "A",
};

export default memo(SmsPackageStatus);
